// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.lease.CloneLeaseWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CloneLeaseWebApiHandler_cloneLease } from '@zg-rentals/ts-leasing-client';

import type { CloneLeaseRequestDto, CloneLeaseResponseDto } from '@zg-rentals/ts-leasing-client';

export interface CloneLeaseWebApiHandler_cloneLease_Args {
  postData: CloneLeaseRequestDto;
}

export type CloneLeaseWebApiHandler_cloneLease_Options = UseMutationOptions<
  CloneLeaseResponseDto,
  unknown,
  CloneLeaseWebApiHandler_cloneLease_Args
>;

/**
 * clone existing lease and migrate to newer template if available
 */
export const useCloneLeaseWebApiHandler_cloneLease = ({
  httpClient,
  ...options
}: Omit<CloneLeaseWebApiHandler_cloneLease_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CloneLeaseWebApiHandler_cloneLease_Args) =>
      CloneLeaseWebApiHandler_cloneLease(args.postData, httpClient),
  });
};
